// 难度选择弹窗
import CustomPopup from "../../../../components/CustomPopup";
import React, {useContext, useEffect} from "react";
import {VsPlayerLevel} from "../../../../types/IPage.ts";
import './DifficultySelectionDialog.css'
import {ThemeContext} from "../../../../providers/themeContext/theme-context.tsx";
import {GAEvents} from "../../../../common/utils/GA4/GAEvents.ts";
import {useMusicContext} from "../../../../providers/musicProvider/music-player-context.tsx";

interface IDifficultySelectionDialogProps {
    isOpen: boolean;
    onClose: () => void;
    createRoomByHardLevel: (level: VsPlayerLevel) => void;
}

const DifficultySelectionDialog: React.FC<IDifficultySelectionDialogProps> = ({
                                                                                  isOpen,
                                                                                  onClose,
                                                                                  createRoomByHardLevel
                                                                              }) => {
    // 主题管理器
    const {imgUrls} = useContext(ThemeContext);
    // 全局音乐provider
    const musicManager = useMusicContext();

    useEffect(() => {
        if (isOpen) {
            // GA埋点
            GAEvents.createMatchPageShow()
        }
    }, [isOpen]);

    // 选择难度，打开对战链接弹窗
    const handleLevelSelect = (level: VsPlayerLevel) => {
        const str = level === 1 ? "Easy" : level === 2 ? "Medium" : "Hard";
        musicManager.playButtonSound()
        createRoomByHardLevel(level)
        // GA埋点
        GAEvents.vsPlayerSelectDifficulty(str)
    }

    return (
        <CustomPopup isOpen={isOpen} onClose={onClose}>
            <div className="difficulty-selection-modal-container">
                <img className="common-dialog-embellish-bg-left-top" src={imgUrls.leftTopBgDialogUrl} alt="pic"/>
                <img className="common-dialog-embellish-bg-right-bottom" src={imgUrls.rightBottomBgDialogUrl}
                     alt="pic"/>
                {/*标题*/}
                <div
                    className="font-size-16 my-roboto-bold text-center margin-top-11 height-26 display-flex-row display-flex-justify-content-center display-flex-align-items-center">
                    Select Game Difficulty
                    <img onClick={onClose} src={imgUrls.closerBtnGreyUrl} className="exit-close-btn"
                         alt="pic"/>
                </div>
                <div className="display-flex-row width-273 margin-left-right-auto margin-top-13">
                    <div onClick={() => handleLevelSelect(VsPlayerLevel.EASY)}
                         className="difficulty-first-card-bg-color border-radius-10 width-133 height-93 font-size-24 my-roboto-bold text-italic display-flex-row display-flex-justify-content-center display-flex-align-items-center color-white">
                        <img className="width-51 height-32 object-fit-contain" src={imgUrls.vsPlayerEasyText} alt="pic"/>
                    </div>
                    <div onClick={() => handleLevelSelect(VsPlayerLevel.MEDIUM)}
                         className="difficulty-second-card-bg-color margin-left-10 border-radius-10 width-133 height-93 font-size-24 my-roboto-bold text-italic display-flex-row display-flex-justify-content-center display-flex-align-items-center color-white">
                        <img className="width-86 height-32 object-fit-contain" src={imgUrls.vsPlayerMiddleText} alt="pic"/>
                    </div>
                </div>
                <div onClick={() => handleLevelSelect(VsPlayerLevel.HARD)}
                     className="margin-top-10 width-270 height-93 margin-left-right-auto border-radius-10 difficulty-third-card-bg-color font-size-27 color-white my-roboto-bold display-flex-row display-flex-align-items-center display-flex-justify-content-center">
                    <img className="width-74 height-40 object-fit-contain" src={imgUrls.vsPlayerHardText} alt="pic"/>
                </div>
            </div>
        </CustomPopup>
    )
}

export default DifficultySelectionDialog;